import Model from '@/models/Model.js';

export default class GroupCategory extends Model {
    static entity = 'group_categories';

    static modelName = 'GroupCategory';

    static fields() {
        return {
            id: this.attr(null),
            name: this.attr(null),

            ...super.fields(),
        };
    }
}
